import React from "react";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";

import { LinkButton, LinkButtonProps } from "components/Button/LinkButton";
import { FaIcon } from "components/FaIcon/FaIcon";

export type DownloadButtonProps = LinkButtonProps;

export function DownloadButton({ children, ...props }: DownloadButtonProps) {
    const downloadIcon = <FaIcon icon={faDownload} />;

    return (
        <LinkButton
            iconLeft={downloadIcon}
            variation="primary"
            aria-label="Download"
            {...props}
        >
            {children}
        </LinkButton>
    );
}
